export const getBase64PrefixForJpeg = (imageBase64: string): string => {
  return `data:image/jpeg;base64,${imageBase64}`;
};
